import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "copy-right-mobile-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("Made with ♥ by "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.inovex.de/de/kontakt/",
    target: "_blank"
  }, " inovex")
], -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = ["disabled"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.inovex.de/en/datenschutz/",
    target: "_blank"
  }, "Data protection")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.inovex.de/en/impressum/",
    target: "_blank"
  }, "Legal Notice")
], -1)

import { ROUTES } from '@/router/routes';
import IconComponent from '@/components/IconComponent.vue';
import IconSpeedometer from '@/assets/VueIcons/IconSpeedometer.vue';
import { currentRequests, MAX_CONCURRENT_REQUESTS } from '@/stores/gameStore';
import { ref } from 'vue';
import IconChevronDown from '@/assets/VueIcons/IconChevronDown.vue';
import IconChevronUp from '@/assets/VueIcons/IconChevronUp.vue';
import { updateCurrentRequests } from '@/utils/utilizatioHelper';

export default /*#__PURE__*/_defineComponent({
  __name: 'MobileFooterComponent',
  props: {
  location: {
    type: String
  }
},
  setup(__props) {

const props = __props;
const isOpen = ref(false);
const isTooltipVisible = ref(false);
const openFooter = () => {
  isOpen.value = !isOpen.value;
};
const toogleTooltip = () => {
  isTooltipVisible.value = !isTooltipVisible.value;
};
setInterval(updateCurrentRequests, 5000);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      `footer-container-mobile --${props.location}`,
      { '--border': isOpen.value }
    ])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        class: "footer-button",
        onClick: openFooter
      }, [
        _createVNode(IconComponent, null, {
          default: _withCtx(() => [
            (!isOpen.value)
              ? (_openBlock(), _createBlock(IconChevronDown, { key: 0 }))
              : (_openBlock(), _createBlock(IconChevronUp, { key: 1 }))
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(`game__copy-right--mobile --${props.location}`)
      }, _hoisted_3, 2),
      _createElementVNode("div", {
        class: _normalizeClass([`tooltip-mobile --${props.location}`])
      }, [
        _createElementVNode("button", {
          disabled: _unref(currentRequests) < _unref(MAX_CONCURRENT_REQUESTS),
          class: "footer-button --traffic",
          onClick: toogleTooltip
        }, [
          _createVNode(IconComponent, {
            "show-title": false,
            class: _normalizeClass({
              'icon-traffic--mobile': true,
              '--too-high': _unref(currentRequests) >= _unref(MAX_CONCURRENT_REQUESTS)
            })
          }, {
            default: _withCtx(() => [
              _createVNode(IconSpeedometer)
            ]),
            _: 1
          }, 8, ["class"]),
          _createElementVNode("span", {
            class: _normalizeClass({
              tooltiptext_mobile: true,
              '--too-high': _unref(currentRequests) >= _unref(MAX_CONCURRENT_REQUESTS),
              '--visible': isTooltipVisible.value
            })
          }, "increased data traffic", 2)
        ], 8, _hoisted_4)
      ], 2)
    ]),
    _withDirectives(_createElementVNode("div", {
      class: _normalizeClass(["p-4 transition-max-height duration-500 ease-in-out", {
        'max-h-0 overflow-hidden': !isOpen.value,
        'max-h-96 copy-right-mobile__legal': isOpen.value
      }])
    }, [
      _createElementVNode("div", null, [
        _createElementVNode("a", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push(_unref(ROUTES).TEAM)))
        }, "Team")
      ]),
      _hoisted_5,
      _hoisted_6,
      _createElementVNode("div", null, [
        _createElementVNode("a", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push(_unref(ROUTES).DISCLAIMER)))
        }, "Disclaimer")
      ])
    ], 2), [
      [_vShow, isOpen.value]
    ])
  ], 2))
}
}

})